import LibTextareaAutosize from 'react-textarea-autosize';
import type { TextareaAutosizeProps as LibTextareaAutosizeProps } from 'react-textarea-autosize';
import { forwardRef } from 'react';

type TextareaAutosizeProps = LibTextareaAutosizeProps;

const TextareaAutosize = forwardRef<HTMLTextAreaElement, TextareaAutosizeProps>((props, ref) => {
  return <LibTextareaAutosize ref={ref} {...props} />;
});

export default TextareaAutosize;
